import React from 'react';
import logoIscert from '../assets/logo-iscert.svg';
import loadingGif from '../assets/loading.gif';

export const LoadingPage = () => {

    return (
            <section id="cripto">
                    <div className="brand-logo">
                        <img className="img-fluid" src={logoIscert} alt="Logotipo iSCert"/>
                    </div>
                    <div className="section-content">
                        <h2 className="txt-info">Aguarde un momento..</h2>
                        <img className="img-loading" src={loadingGif} alt="Loading"/>
                        <p className="txt-sub">
                            Esta página se recargará automáticamente una vez finalice la operación.
                        </p>
                    </div>
            </section>
);
};
